export enum ProductName {
  LearningToolkit = 'learning_toolkit',
  Gift = 'gift',
  OnCall = 'on_call',
}

export enum Page {
  AddOnPrePurchasePage = 'Checkout Add-on Screen',
  AddOnPostPurchasePage = 'Post Purchase Add-on Screen',
  ThanksPostPurchasePage = 'Post Purchase Add-on Thanks Screen',
  CongratsPostPurchasePage = 'Post Purchase Add-on Congrats Screen',
  PaymentErrorPostPurchasePage = 'Post Purchase Add-on Payment Error Screen',
}
